<template>
  <div>
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item
        :name="idx"
        v-for="(item, key, idx) in repeatMap"
        :key="'repeatMap' + idx"
      >
        <template slot="title">
          <div class="colTitle">
            <div class="content" style="font-size: 1.2em">{{ key }}</div>
            <div class="repeatTime">
              <span>{{ item.length }}</span>
              <br />
              <span>重复次数</span>
            </div>
            <el-button type="info" plain>展开处理</el-button>
          </div>
        </template>
        <div class="questionContainer">
          <div
            class="questionBox"
            v-for="(que, queIdx) in item"
            :key="'que' + queIdx"
          >
            <div
              class="actBar"
              style="display: flex; justify-content: flex-end"
            >
              <el-button type="primary" plain size="mini">删除</el-button>
              <el-button type="info" plain size="mini" style="margin-left: 10px"
                >编辑</el-button
              >
            </div>
            <el-row class="questionFlex">
              <el-col :span="14" class="questionContent">
                <h3>查看试题详细信息</h3>
                <div class="title">
                  <span
                    :style="{
                      color: colorMap[que.questionTypeId],
                      border: '1px solid ' + colorMap[que.questionTypeId],
                      padding: '2px 4px',
                    }"
                    >{{ questionTypeMap[que.questionTypeId] }}</span
                  >&nbsp;&nbsp;<strong style="font-size: 1.1em">{{
                    que.content
                  }}</strong>
                  <span>({{ que.score }}分)</span>
                </div>
                <div
                  class="answerBar"
                  v-if="
                    que.questionTypeId == 1 ||
                    que.questionTypeId == 2 ||
                    que.questionTypeId == 4
                  "
                >
                  <p
                    v-for="(asw, aswIdx) in que.answerDTOList"
                    :key="'asw' + aswIdx"
                  >
                    {{
                      que.questionTypeId == 4
                        ? ["真", "假"][asw.showNo - 1]
                        : String.fromCharCode(asw.showNo + 64)
                    }}、{{ asw.content }}
                  </p>
                </div>
                <p
                  v-if="
                    que.questionTypeId == 1 ||
                    que.questionTypeId == 2 ||
                    que.questionTypeId == 4
                  "
                >
                  正确答案: <strong>{{ que.answerDTOList | keyFilter }}</strong>
                </p>
                <p v-else>
                  正确答案:
                  <strong>
                    {{
                      que.answerDTOList
                        .reduce((total, cur) => {
                          total.push(cur.content);
                          return total;
                        }, [])
                        .join("，")
                    }}</strong
                  >
                </p>
                <p class="greyFont">
                  题目解析 <strong>{{ que.analysis }}</strong>
                </p>
                <p>
                  标签：{{
                    que.labelDTOList
                      .reduce((total, cur) => {
                        total.push(cur.labelName);
                        return total;
                      }, [])
                      .join(",")
                  }}
                </p>
              </el-col>
              <el-col :span="10" class="questionConclude">
                <h3>试题答对答错数分布</h3>
              </el-col>
            </el-row>
            <div class="distribute">
              <!-- <p class="bigFont">该试卷使用于下列试卷</p>
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="name" label="姓名" width="120"></el-table-column>
                <el-table-column  label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                    <el-button type="text" size="small">编辑</el-button>
                  </template>
                </el-table-column>
              </el-table>
              </div>-->
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { checkRepeat } from "@/api/question.js";
export default {
  data() {
    return {
      activeNames: "",
      repeatMap: {},
      questionTypeMap: {
        1: "单选题",
        2: "多选题",
        3: "填空题",
        4: "问答题",
        5: "判断题",
      },
      colorMap: {
        1: "#618afd",
        2: "#80b830",
        3: "#ffecd9",
        4: "#24a1cf",
        5: "#7d8ca9",
      },
    };
  },
  filters: {
    keyFilter(item) {
      return item
        .reduce((total, cur) => {
          if (cur.isCorrect == 2) {
            total.push(String.fromCharCode(cur.showNo + 64));
          }
          return total;
        }, [])
        .join("，");
    },
  },
  created() {},
  mounted() {
    checkRepeat().then((data) => {
      this.repeatMap = data;
      console.log(data);
    });
  },
  methods: { handleChange() {} },
};
</script>

<style scoped lang="less">
.colTitle {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  .repeatTime {
    line-height: 18px;
    width: 150px;
    text-align: center;
  }
  .content {
    flex: 1;
  }
}
.questionContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  // font-size: 1.em;
  padding: 0 2%;
  .questionBox {
    width: 48%;
  }
}
/deep/ .el-collapse-item__header {
  height: 80px;
  padding: 0 20px;
  .el-collapse-item__arrow {
    display: none;
  }
}
</style>
